module.exports = __webpack_public_path__ + "static/media/UI_img4.307f2d60.png";